import { Box } from '@mui/material'
import { BetDetailsTableComponent } from '@/views/components'
import { useContributionsBetDetails } from '@/views/contributions/hooks/use-bet-details.hook'

type Props = {
  id: string
}

export const ContributionsBetDetailsReport = ({ id }: Props) => {
  const { sortedRows, createSortHandler, order, orderBy, headCells } =
    useContributionsBetDetails({ contributionId: id })

  return (
    <Box width="100%" margin="40px auto">
      <Box overflow="hidden">
        <BetDetailsTableComponent
          sortedRows={sortedRows}
          order={order}
          orderBy={orderBy}
          createSortHandler={createSortHandler}
          headCells={headCells}
        />
      </Box>
    </Box>
  )
}
